import { Images, QuestionGroup, QuestionType, ScenarioStep, Steps } from '../state/interfaces'
import {
  addressLocation,
  emailAddress,
  confirm,
  thanks,
  phoneNumber,
  lastName,
  firstName,
  selectCurrentProvider,
  phoneResidential,
} from './common-steps'
import { currentProviderInternet } from './internet-steps'
import { currentProviderMobile } from './mobile-steps'

// export const startLead: ScenarioStep = {
//   id: Steps.START_LEAD,
//   group: QuestionGroup.LEAD,
//   question: 'start-lead_question',
//   tip: 'start-lead_tip',
//   type: QuestionType.LEAD,
//   next: Steps.ADDRESS_LOCATION,
//   answers: [
//     {
//       id: 'start',
//       text: 'common_next',
//     },
//   ],
// }

export const thanksLead: ScenarioStep = {
  ...thanks,
  question: 'thanks-lead_question',
  tip: 'thanks-lead_tip',
}

export const addressLocationLead: ScenarioStep = {
  ...addressLocation,
  group: QuestionGroup.LEAD,
  tip: 'address-location_tip',
  answerPlaceholder: 'address-location-lead_answerPlaceholder',
  next: Steps.PROVIDER_AVAILABILITY,
}

export const emailAddressLead: ScenarioStep = {
  ...emailAddress,
  id: Steps.EMAIL_ADDRESS_LEAD,
  question: 'email-address-lead_question',
  tip: 'email-address-lead_tip',
  group: QuestionGroup.LEAD,
  next: Steps.ADDRESS_LOCATION,
  metadata: { grandImage: Images.LEAD_1 },
}

export const emailAddressLeadC: ScenarioStep = {
  ...emailAddress,
  id: Steps.EMAIL_ADDRESS_LEAD,
  question: 'email-address-lead_question',
  tip: 'email-address-lead_tip',
  group: QuestionGroup.LEAD,
  next: Steps.CURRENT_PROVIDER_MOBILE_LEAD,
  metadata: { grandImage: Images.LEAD_1 },
}

export const emailAddressLeadCC: ScenarioStep = {
  ...emailAddress,
  id: Steps.EMAIL_ADDRESS_LEAD,
  question: 'email-address-lead_question',
  tip: 'email-address-lead_tip',
  group: QuestionGroup.LEAD,
  next: Steps.CURRENT_PROVIDER_INTERNET_LEAD,
  metadata: { grandImage: Images.LEAD_1 },
}

export const confirmLead: ScenarioStep = {
  ...confirm,
  id: Steps.CONFIRM_LEAD,
  group: QuestionGroup.LEAD,
  answerPlaceholder: 'confirm-lead_answerPlaceholder',
  next: Steps.THANKS,
}

export const providerAvailability: ScenarioStep = {
  id: Steps.PROVIDER_AVAILABILITY,
  group: QuestionGroup.DEFAULT,
  type: QuestionType.PROVIDER_AVAILABILITY,
  answers: [
    {
      id: 'continue-with-provider',
      text: 'common_continue',
      next: Steps.FIRST_NAME,
    },
  ],
}

export const newClientVerification: ScenarioStep = {
  id: Steps.NEW_CLIENT_VERIFICATION,
  group: QuestionGroup.DEFAULT,
  type: QuestionType.NEW_CLIENT_VERIFICATION,
  answers: [
    {
      id: 'continue-with-provider',
      text: 'common_continue',
    },
  ],
  next: Steps.ADDRESS_LOCATION,
}

export const phoneNumberLead: ScenarioStep = {
  ...phoneNumber,
  next: Steps.CONFIRM_LEAD,
}

export const phoneNumberLeadB: ScenarioStep = {
  ...phoneNumber,
  next: Steps.CURRENT_PROVIDER_MOBILE_LEAD,
}

export const currentProviderMobileLead: ScenarioStep = {
  ...currentProviderMobile,
  id: Steps.CURRENT_PROVIDER_MOBILE_LEAD,
  next: Steps.CONFIRM_LEAD,
}

export const currentProviderMobileLeadC: ScenarioStep = {
  ...currentProviderMobile,
  id: Steps.CURRENT_PROVIDER_MOBILE_LEAD,
  next: Steps.NEW_CLIENT_VERIFICATION,
}

export const currentProviderInternetLead: ScenarioStep = {
  ...currentProviderInternet,
  id: Steps.CURRENT_PROVIDER_INTERNET_LEAD,
  next: Steps.NEW_CLIENT_VERIFICATION,
}

// Mektel specific steps
export const emailAddressLeadMektel: ScenarioStep = {
  ...emailAddress,
  id: Steps.EMAIL_ADDRESS_LEAD,
  question: 'email-address-lead_question',
  tip: 'email-address-lead_tip',
  group: QuestionGroup.LEAD,
  next: Steps.CHOICE_INTERNET_MOBILE_TV,
  metadata: { grandImage: Images.LEAD_1 },
}

export const choiceInternetMobileTv: ScenarioStep = {
  id: Steps.CHOICE_INTERNET_MOBILE_TV,
  group: QuestionGroup.DEFAULT,
  question: 'choice-internet-mobile-tv_question',
  tip: 'choice-internet-mobile-tv_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.TRANSFERRING_SERVICE,
  // metadata: {},
  answers: [
    {
      id: 'home_phone_option',
      text: 'common_home_phone',
      next: Steps.CHOOSE_PHONE_PLAN,
    },
    {
      id: 'television_option',
      text: 'common_television',
      next: Steps.CONFIGURATION_TV,
    },
    {
      id: 'tv_plus_home_phone_option',
      text: 'tv_plus_home_phone',
      next: Steps.CHOOSE_PHONE_PLAN,
    },
    {
      id: 'internet_only_option',
      text: 'internet_only',
    },
  ],
}

export const choosePhonePlan: ScenarioStep = {
  id: Steps.CHOOSE_PHONE_PLAN,
  group: QuestionGroup.DEFAULT,
  question: 'choose-phone-plan_question',
  tip: 'choose-phone-plan_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.TRANSFERRING_SERVICE,
  // metadata: {},
  answers: [
    {
      id: 'unlimited-canada_option',
      text: 'unlimited-canada',
    },
    {
      id: 'unlimited-north-america_option',
      text: 'unlimited-north-america',
    },
  ],
}

export const transferringService: ScenarioStep = {
  id: Steps.TRANSFERRING_SERVICE,
  group: QuestionGroup.DEFAULT,
  question: 'transferring-service_question',
  tip: 'transferring-service_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.TRANSFERRING_SERVICE,
  // metadata: {},
  answers: [
    {
      id: 'yes',
      text: 'common_yes',
      next: Steps.SELECT_CURRENT_PROVIDER,
    },
    {
      id: 'no',
      text: 'common_no',
      next: Steps.INSTALLATION_DATE_PICKER,
    },
  ],
}

export const configurationTV: ScenarioStep = {
  id: Steps.CONFIGURATION_TV,
  group: QuestionGroup.DEFAULT,
  question: 'configuration-tv_question',
  tip: 'configuration-tv_tip',
  type: QuestionType.CHOICE_AS_MAIN_PILL,
  next: Steps.TRANSFERRING_SERVICE,
  answers: [
    {
      id: 'continue',
      text: 'common_continue',
    },
  ],
}

export const chooseChannels: ScenarioStep = {
  id: Steps.CHOOSE_CHANNELS,
  group: QuestionGroup.DEFAULT,
  question: 'choose-channels_question',
  tip: 'choose-channels_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.TRANSFERRING_SERVICE,
  answers: [
    {
      id: '5',
      text: '5-channels',
    },
    {
      id: '10',
      text: '10-channels',
    },
    {
      id: '15',
      text: '15-channels',
    },
    {
      id: '20',
      text: '20-channels',
    },
    {
      id: '25',
      text: '25-channels',
    },
    {
      id: '30',
      text: '30-channels',
    },
    {
      id: 'super-ecran_option',
      text: 'super-ecran',
    },
  ],
}

export const installationDatePicker: ScenarioStep = {
  id: Steps.INSTALLATION_DATE_PICKER,
  group: QuestionGroup.DEFAULT,
  question: 'installation-date-picker_question',
  tip: 'installation-date-picker_tip',
  type: QuestionType.INPUT_DATE_PICKER,
  answerPlaceholder: 'date-picker_answerPlaceholder',
  next: Steps.ADDRESS_LOCATION,
  answers: [],
}

export const addressLocationLeadMektel: ScenarioStep = {
  ...addressLocation,
  group: QuestionGroup.LEAD,
  question: 'address-location-mektel_question',
  tip: 'address-location-mektel_tip',
  answerPlaceholder: 'address-location-mektel_answerPlaceholder',
  next: Steps.FIRST_NAME,
}

export const firstNameMektel: ScenarioStep = {
  ...firstName,
  next: Steps.LAST_NAME,
}

export const lastNameMektel: ScenarioStep = {
  ...lastName,
  next: Steps.PHONE_NUMBER,
}

export const phoneNumberLeadMektel: ScenarioStep = {
  ...phoneNumber,
  next: Steps.FINAL_WORD_MEKTEL,
}

export const finalWordLeadMektel: ScenarioStep = {
  id: Steps.FINAL_WORD_MEKTEL,
  group: QuestionGroup.LEAD,
  question: 'final-word-mektel_question',
  tip: 'final-word-mektel_tip',
  type: QuestionType.TEXTAREA,
  answerPlaceholder: 'final-word-mektel_answerPlaceholder',
  next: Steps.CONFIRM_LEAD,
  answers: [],
}

export const selectCurrentProviderLeadMektel: ScenarioStep = {
  ...selectCurrentProvider,
  question: { key: 'select-current-provider_question', options: { providerType: 'Internet' } },
  tip: 'select-current-provider-lead-mektel_tip',
  next: Steps.SERVICE_TRANSFERRED,
}

export const serviceTransferSelected: ScenarioStep = {
  id: Steps.SERVICE_TRANSFERRED,
  group: QuestionGroup.DEFAULT,
  question: 'service-transferred_question',
  tip: 'service-transferred_tip',
  type: QuestionType.MULTICHOICE_AS_CHECKBOXES,
  next: Steps.INSTALLATION_DATE_PICKER,
  answers: [
    {
      id: 'internet',
      text: 'common_internet',
      metadata: { isChecked: true },
    },
    {
      id: 'home-phone',
      text: 'common_home_phone',
      metadata: { isChecked: false },
    },
    {
      id: 'television',
      text: 'common_television',
      metadata: { isChecked: false },
    },
  ],
}

export const transferInternet: ScenarioStep = {
  id: Steps.TRANSFER_INTERNET,
  group: QuestionGroup.DEFAULT,
  question: 'transfer-internet_question',
  tip: 'transfer-internet_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.INSTALLATION_DATE_PICKER,
  answers: [
    {
      id: 'fibre',
      text: 'common_fibre',
    },
    {
      id: 'dsl',
      text: 'common_dsl',
    },
    {
      id: 'cable',
      text: 'common_cable',
    },
    {
      id: 'i-dont-know',
      text: 'common_i-dont-know',
    },
  ],
}

export const phoneResidentialLeadMektel: ScenarioStep = {
  ...phoneResidential,
  next: Steps.INSTALLATION_DATE_PICKER,
}

// end Mektel specific steps
